import React, { FC, useEffect } from 'react';
import { useTracking, GtmEventCategoryData } from '@empiriecom/module-components/hooks/useTracking';
import BreadcrumbList from '@empiriecom/module-components/Breadcrumb/List';
// import Skeleton from '@empiriecom/module-components/Breadcrumb/List/skeleton';
import {
  BreadcrumbData,
  BreadcrumbIndependentProps,
} from '@empiriecom/module-components/Breadcrumb/types';
import useDebounce from '@empiriecom/module-components/hooks/useDebounce';
import useBreadcrumb from '../ProductContext/hooks/useBreadcrumb';
import { isClientSide } from '../utils';

export const Breadcrumb: FC<BreadcrumbIndependentProps> = ({
  category,
  companyId,
  locale: userLocale,
  ...props
}) => {
  // if (!category || !companyId) {
  //   return <Skeleton />;
  // }
  const dispatchGTMEvent = useTracking();
  const { isLoading, breadcrumb: response } = useBreadcrumb();
  const isDebounceLoading = useDebounce(isLoading, 300);

  useEffect(() => {
    if (response && response.breadCrumb) {
      dispatchGTMEvent<GtmEventCategoryData>({
        categoryId: category.toString(),
        categoryIds: response.breadCrumb.map((item) => item.id),
        categoryPath: response.breadCrumb.map((item) => item.name),
        event: 'categoryData',
        eventCategory: 'data',
      });
    }
  }, [JSON.stringify(response)]); // Use object here to identify change to valid response. Shouldn't be a problem on rerender.
  if (!response || (isClientSide ? isDebounceLoading : isLoading)) {
    // return <Skeleton />;
    return null;
  }
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BreadcrumbList data={response as BreadcrumbData} {...props} />;
};

export default Breadcrumb;
